// Predefined tag palette. Custom tags fall back to a neutral scheme.
export const TAG_PRESETS = [
  { id: "Tropical",     label: "Tropical",     tone: "#22d3ee" },  // cyan
  { id: "Winter",       label: "Winter",       tone: "#60a5fa" },  // sky-blue
  { id: "Severe",       label: "Severe",       tone: "#d90429" },  // GWN red
  { id: "Model Update", label: "Model Update", tone: "#ffd60a" },  // orange
  { id: "Discussion",   label: "Discussion",   tone: "#a78bfa" },  // violet
  { id: "Heat",         label: "Heat",         tone: "#fb923c" },  // amber
  { id: "Flooding",     label: "Flooding",     tone: "#38bdf8" },  // blue
  { id: "Fog",          label: "Fog",          tone: "#94a3b8" },  // slate
];

export const TAG_IDS = TAG_PRESETS.map((t) => t.id);

export function toneFor(tag) {
  return TAG_PRESETS.find((t) => t.id.toLowerCase() === (tag || "").toLowerCase())?.tone || "#9ca3af";
}

// Tag chip. `interactive` = show hover/active state (used by filter bars).
export function TagChip({ tag, active, onClick, size = "sm", removable, onRemove }) {
  const tone = toneFor(tag);
  const isBtn = !!onClick;
  const Component = isBtn ? "button" : "span";
  const base =
    size === "xs"
      ? "px-2 py-0.5 text-[9px] tracking-[0.3em]"
      : size === "md"
      ? "px-3 py-1 text-[11px] tracking-[0.25em]"
      : "px-2.5 py-0.5 text-[10px] tracking-[0.25em]";
  return (
    <Component
      onClick={onClick}
      data-testid={isBtn ? `tag-chip-${tag}` : undefined}
      className={`inline-flex items-center gap-1.5 rounded-full border font-oswald font-bold uppercase transition-colors ${base} ${
        active
          ? "border-transparent text-black"
          : "border-white/15 bg-black/50 text-white hover:border-white/40"
      }`}
      style={
        active
          ? { backgroundColor: tone, boxShadow: `0 0 0 1px ${tone}` }
          : { color: "white" }
      }
      type={isBtn ? "button" : undefined}
    >
      <span
        className="inline-block h-2 w-2 rounded-full"
        style={{ backgroundColor: tone }}
      />
      {tag}
      {removable && (
        <span
          role="button"
          onClick={(e) => { e.stopPropagation(); onRemove?.(); }}
          className="ml-0.5 text-white/80 hover:text-white"
          aria-label={`Remove ${tag}`}
        >
          ×
        </span>
      )}
    </Component>
  );
}
